import React from "react"
import WOW from "react-wow"
import Link from "src/components/util/TransitionLink"
import * as S from "./styled"
import Button from "src/components/ui/Button"

const BlogItem = ({ description, title, img, slug }) => {
  return (
    <WOW animation="fadeIn">
      <S.BlogItemWrapper>
        <Link to={slug}>
          {img.childImageSharp ? (
            <S.BlogItemImgFluid
              fluid={img.childImageSharp.fluid}
              alt={title}
              effect="blur"
            />
          ) : (
            <S.BlogItemImg src={img.publicURL} alt={title} effect="blur" />
          )}
        </Link>
        <S.BlogItemCaption>
          <WOW animation="fadeInUp">
            <S.BlogItemTitle>{title}</S.BlogItemTitle>
            <S.BlogItemDesc>{description}</S.BlogItemDesc>
            <S.BlogItemMore to={slug}>
              <Button color="dark" hasIconAfter="ChevronRight" size="sm">
                Leia
              </Button>
            </S.BlogItemMore>
          </WOW>
        </S.BlogItemCaption>
      </S.BlogItemWrapper>
    </WOW>
  )
}

export default BlogItem
